import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { nanoid } from "@reduxjs/toolkit";
import { getUnitCost, getVatByMstCategoryPrice } from "./HelperFunction";
import { getSupplierProductName } from "./HelperProduct";
export function getVisibleColumns(param) {
    var allColumns = param.allColumns, docType = param.docType;
    return allColumns.filter(function(col) {
        var _col_meta;
        var hiddenIn = ((_col_meta = col.meta) === null || _col_meta === void 0 ? void 0 : _col_meta.hiddenIn) || [];
        return !hiddenIn.includes(docType);
    });
}
export var COLUMN_VISIBILITY_RULES = {
    HIDE_PURCHASE_COST: [
        "QO",
        "SO",
        "DO",
        "INVOICE"
    ]
};
export var handleRowSelectDefault = function(param) {
    var ids = param.ids, setProductRow = param.setProductRow, filteredItems = param.filteredItems, optionsWarehouse = param.optionsWarehouse, values = param.values;
    var selectedIDs = new Set(ids);
    var selectedRows = filteredItems.filter(function(row) {
        return selectedIDs.has(row.productID);
    });
    if (selectedRows.length > 0) {
        setProductRow(function(productRow) {
            var _selectedRows__dimProduct, _selectedRows__dimProduct1;
            var warehouseID = values.dim_warehouse_id;
            var warehouse = optionsWarehouse.find(function(item) {
                return values.dim_warehouse_id === item.value;
            });
            var warehouseName = warehouse ? warehouse.label : "";
            var vatByMstCatPrice = getVatByMstCategoryPrice(values.dim_mst_price_category_id, selectedRows[selectedRows.length - 1].dim_mst_vat_id, selectedRows[selectedRows.length - 1].vat);
            var lastSelectedRow = _object_spread_props(_object_spread({}, selectedRows[selectedRows.length - 1]), {
                rowID: nanoid(),
                supplierCode: (_selectedRows__dimProduct = selectedRows[selectedRows.length - 1].dimProduct) === null || _selectedRows__dimProduct === void 0 ? void 0 : _selectedRows__dimProduct.supplier_code,
                supplierName: getSupplierProductName((_selectedRows__dimProduct1 = selectedRows[selectedRows.length - 1].dimProduct) === null || _selectedRows__dimProduct1 === void 0 ? void 0 : _selectedRows__dimProduct1.supplier_names),
                warehouseID: warehouseID,
                warehouseName: warehouseName,
                dim_mst_vat_id: vatByMstCatPrice.dim_mst_vat_id,
                vat: vatByMstCatPrice.vat
            });
            var existingRowIndex = productRow.findIndex(function(row) {
                return !row.productID;
            });
            if (existingRowIndex !== -1) {
                var updatedRows = _to_consumable_array(productRow);
                updatedRows[existingRowIndex] = lastSelectedRow;
                return updatedRows;
            } else {
                return _to_consumable_array(productRow).concat([
                    lastSelectedRow
                ]);
            }
        });
    }
};
